import { USStates } from '@constants/Common/personalInfo.constants'
import { IContact } from '@dataTypes/contact.type'

interface GetAddressProps {
  address?: string
  city?: string
  state?: string
  zip?: string
}
export const getFullAddress = (
  addressProps: GetAddressProps,
  nullValue: string = '-',
): string => {
  const { address, city, state, zip } = addressProps
  let fullAddress = ''
  if (address) fullAddress += `${address}`
  if (city) fullAddress += `, ${city}`
  if (state) fullAddress += `, ${state}`
  if (zip) fullAddress += `, ${zip}`
  return fullAddress.length > 0 ? fullAddress : nullValue
}

export const getCityList = (contactList: IContact[]): string[] => {
  const cityList = contactList
    .map((contact) => contact.city)
    .filter((city): city is string => city !== undefined && city !== null)

  return Array.from(new Set(cityList))
}

export const getStateList = (contactList: IContact[]): string[] => {
  const stateList = contactList
    .map((contact) => contact.state)
    .filter((state): state is string => state !== undefined && state !== null)

  return Array.from(new Set(stateList))
}

export const toStateCode = (input?: string | null): string => {
  if (!input) return ''
  const trimmed = input.trim()
  if (!trimmed) return ''
  if (trimmed.length === 2) {
    const upper = trimmed.toUpperCase()
    return USStates.some((s) => s.value === upper) ? upper : ''
  }
  const lower = trimmed.toLowerCase()
  const match = USStates.find(
    (s) => s.label.split(' (')[0].toLowerCase() === lower,
  )
  return match?.value ?? ''
}
